import { FC } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { trackEvent } from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link';
import Logo2020 from 'dibs-icons/exports/Logo2020';
import Logo2020Trade from 'dibs-icons/exports/Logo2020Trade';
import { LocalizedLogoVipIcon } from 'dibs-elements/exports/LocalizedLogoVipIcon';

import styles from './LogoNav-style.scss';

const trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
    label: 'home link|1stdibs logo',
};

type Props = {
    isUserTypeTrade?: boolean;
    isUserTypeVip?: boolean;
    isStickyLogo?: boolean;
};

const Logo: FC<Props> = ({ isUserTypeTrade, isUserTypeVip, isStickyLogo }) => {
    let LogoComponent = Logo2020;
    if (isUserTypeTrade) {
        LogoComponent = Logo2020Trade;
    } else if (isUserTypeVip) {
        LogoComponent = LocalizedLogoVipIcon;
    }

    const iconWrapperClassName = classNames(styles.iconWrapper, {
        [styles.stickyLogo]: isStickyLogo,
    });

    return (
        <div className={styles.wrapper}>
            <Link
                ariaLabel="1stDibs"
                href="/"
                className={iconWrapperClassName}
                onClick={event => {
                    trackEvent(trackingObj, event);
                }}
            >
                <LogoComponent />
            </Link>
        </div>
    );
};

type PartialState = {
    header: Props;
};

const mapStateToProps = (state: PartialState): Props => {
    const { isUserTypeTrade, isUserTypeVip } = state.header;

    return {
        isUserTypeTrade,
        isUserTypeVip,
    };
};

export default connect(mapStateToProps)(Logo);
